import { useAuth0 } from '@auth0/auth0-react';
import { HideLayoutContext } from './ProtectedRoute';

const HideLayoutProvider = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuth0();
  const hideLayout = !isAuthenticated;
  return (
    <HideLayoutContext.Provider value={hideLayout}>
      {children}
    </HideLayoutContext.Provider>
  );
};

export default HideLayoutProvider;